import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './resources/translations/en.json';
import sv from './resources/translations/sv.json';

import dayjs from 'dayjs';
require('dayjs/locale/en');
require('dayjs/locale/sv');

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sv: { translation: sv },
  },
  lng: 'sv', // Default language
  fallbackLng: 'sv', // Use this language if the preferred language is not available
  interpolation: {
    escapeValue: false,
  },
});

dayjs.locale(i18n?.language);

export default i18n;
